module.exports = __webpack_public_path__ + "img/tier1_pic3.23f714f9.png";